import { useId } from 'react';
import { formatMoneyInput, moneyWords, parseMoneyInput } from '../moneyInput.ts';

/**
 * Every money box (F-100, A-#556): it takes "1,000", "$1,000.50" or "1000", keeps exactly what is typed while focused,
 * and on leaving shows a valid value with its commas. It is never rewritten under the caret. The form reads the value
 * with moneyText() when it sends. No other prop passes through, so web/test/money-input.test.ts can read every use.
 */
export function MoneyBox({ id, value, onChange, maxDigits = 12, negative = false, required = false, className, lead,
  words = true }: {
  /** For an outside <label htmlFor>; a box inside its own label passes none. */
  id?: string;
  /** Exactly as typed: the form's own state. */
  value: string;
  onChange: (typed: string) => void;
  /** Digits before the point: 12 (numeric(14,2)), 8 for the billing rate, 6 for the cost caps. */
  maxDigits?: number;
  /** The statement balance only (an overdrawn account). */
  negative?: boolean;
  required?: boolean;
  className: string;
  /** Words before the help text, in the same line. */
  lead?: string;
  /** false: the caller says it already. */
  words?: boolean;
}) {
  const own = useId();
  const hintId = `${id ?? own}-money-hint`;
  const read = parseMoneyInput(value, { maxDigits, negative });
  return (
    <>
      <input id={id} inputMode="decimal" className={className} value={value} required={required}
             onChange={(e) => onChange(e.target.value)}
             onBlur={() => { if (read.kind === 'ok' && formatMoneyInput(read.text) !== value) onChange(formatMoneyInput(read.text)); }}
             aria-invalid={read.kind === 'bad'} aria-describedby={words ? hintId : undefined} />
      {words && <p id={hintId} className="mt-1 text-sm text-neutral-600">{lead ? `${lead} ` : ''}{moneyWords(maxDigits)}</p>}
    </>
  );
}
